module.exports = __webpack_public_path__ + "static/media/date-picker-dark.0255d35e.svg";